import useAutoFetch from "v4/hooks/useAutoFetch";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import { generateUrl } from "v4/services/api.service";
import { ENTITY_SERIALIZATION } from "v4/data/apiRoutes";
import { PROSPECT } from "v4/data/entities";

export default function useExportExternalAction(entityId) {
    const { currentRoute } = useNavigation();

    const entity = currentRoute?.route?.search_type ?? PROSPECT;

    const { data, isLoading } = useAutoFetch(generateUrl(ENTITY_SERIALIZATION, { entity, id: entityId }), entityId);

    return {
        data,
        isLoading,
    }
}
